export default "__VITE_ASSET__CSWQ6c4$__"